import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validar-os',
  templateUrl: './validar-os.component.html',
  styleUrls: ['./validar-os.component.sass']
})
export class ValidarOsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
